/**
 * 路由名稱
 */
export enum RouterName {
  /** 首頁 */
  LOGIN = 'Login',
  /** 首頁 */
  HOME = 'Home',
  /** 文章設定 */
  ARTICLE_SETTING = 'ArticleSetting',
  /** 文章編輯 */
  ARTICLE_ADD = 'ArticleAdd',
  /** 用戶權限 */
  USER_PERMISSIONS_SETTING = 'UserPermissionsSetting',
  /** 新增用戶 */
  USER_PERMISSIONS_ADD = 'UserPermissionsAdd',
  /** 大事記 */
  RECORD_SETTING = 'RecordSetting',
  /** 新增大事記 */
  RECORD_ADD = 'RecordAdd',
  /** 參數管理 */
  PARAMS_SETTING = 'ParamsSetting',
  /** 參數管理 */
  CATEGORY_SETTING = 'CategorySetting',
  /** 錯誤頁面 */
  ERROR = 'Error',
  /** SSO 轉導頁面 */
  SSO_CALLBACK = 'sso-callback',
  /** SSO 轉導頁面 */
  TEST_PAGE = 'TestPage'
}
